import React, { useEffect, useRef, useState } from "react";
import classes from "./LahzaHero.module.css";
import Spinner from "../Spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../login/Header";
import { useForm, SubmitHandler } from "react-hook-form";
import Modal from "react-bootstrap/Modal";

import video from "../../assests/videos/background.mp4";
import { LahzaRequestDTO } from "../../types/Applicant/LahzaRequestDto";
import { AvailableApplicationsAPI } from "../../API/Applications/AvailableApplicationsAPI";
import { ApplicationTypeDto } from "../../types/Applicant/ApplicationTypeDto";

const LahzaHero = () => {
  useEffect(() => {
    const fetchData = async () => {
      const availableAppliications = new AvailableApplicationsAPI();
      await availableAppliications
        .GetAll()
        .then((data) => {
          if (data.result == null || data.result.length == 0) {
            isOpen(false);
            const msg = t("no_payment_available");
            setMsg(msg);
          } else {
            setApplications(data.result);
            isOpen(true);
          }
        })
        .catch(() => {
          isOpen(false);
          const msg = t("visa_not_available");
          setMsg(msg);
        });
      setIsloading(false);
    };
    fetchData();
  }, []);

  const [paymentUrl, setPaymentUrl] = useState<string>("");
  const iframeRef = useRef(null);
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // Verify the origin
      if (event.origin !== "https://checkout.lahza.io") return;
      try {
        const data =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        if (data != null && data.status != null) {
          if (data.status === "success") {
            navigate("/?msg=success");
          }
        }
      } catch (err) {}
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const COMMISSION_PERCENTAGE = 1.02575;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [price, setPrice] = useState<number>();
  const [currency, setCurrency] = useState<String>("");

  const [msg, setMsg] = useState<string>("");
  const [isloading, setIsloading] = useState<boolean>(true);
  const [applications, setApplications] = useState<ApplicationTypeDto[]>([]);
  const [open, isOpen] = useState<boolean>(false);

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    navigate("/");
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm<LahzaRequestDTO>();

  const formatCurrency = (value: string) => {
    return value
      ? parseFloat(value).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "-";
  };

  const truncateTo2Decimals = (value: number): number => {
    return Math.floor(value * 100) / 100;
  };

  const onSubmit: SubmitHandler<LahzaRequestDTO> = async (data) => {
    if (data.applicationType == -1) {
      alert(t("Error_Required")! + t("visa_application_type"));
    }
    setIsloading(true);
    const availableAppliications = new AvailableApplicationsAPI();
    const response = availableAppliications.GetInitTransaction(data);
    const getUrl = (await response).result.authorization_url;
    setPaymentUrl(getUrl ?? "");
    handleOpenModal();
  };

  return (
    <header className={classes.header}>
      <video autoPlay muted loop className={classes.video}>
        <source src={video} type="video/mp4" media="(min-width: 65rem)" />
      </video>
      <div className={classes.bg}></div>
      <Header dark={true} />

      {isloading ? (
        <section>
          <div className={classes.content}>
            <Spinner />
          </div>
        </section>
      ) : (
        <section>
          <div className={classes.content}>
            {open ? (
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formBox">
                  <div className="formBoxHeader">
                    <div>
                      <p className={classes.titleDark}>{t("visa_title")}</p>
                      {errors.firstName &&
                        errors.firstName?.type === "required" && (
                          <p className="errorMessage">
                            {t("Error_Required")! + t("visa_name_first")!}
                          </p>
                        )}

                      {errors.lastName &&
                        errors.lastName?.type === "required" && (
                          <p className="errorMessage">
                            {t("Error_Required")! + t("visa_name_last")!}
                          </p>
                        )}
                      {errors.mobile && errors.mobile?.type === "required" && (
                        <p className="errorMessage">
                          {t("Error_Required")! + t("visa_mobile")!}
                        </p>
                      )}
                      {errors.email && (
                        <p className="errorMessage">{t("Error_Email")!}</p>
                      )}
                      {errors.mobile &&
                        (errors.mobile?.type === "minLength" ||
                          errors.mobile?.type === "maxLength") && (
                          <p className="errorMessage">{t("Error_Mobile")!}</p>
                        )}
                      {errors.applicationType && (
                        <p className="errorMessage">
                          {t("Error_Required")! + t("visa_application_type")!}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className={"grid grid--2--cols"}>
                    <div>
                      <label htmlFor="material">{t("visa_name_first")!}</label>
                      <input
                        {...register("firstName", {
                          required: true,
                        })}
                        className="textbox"
                        placeholder={t("visa_name_first")!}
                        type="textbox"
                      />
                    </div>
                    <div>
                      <label htmlFor="material">{t("visa_name_last")!}</label>
                      <input
                        {...register("lastName", {
                          required: true,
                        })}
                        className="textbox"
                        placeholder={t("visa_name_last")!}
                        type="textbox"
                      />
                    </div>
                  </div>
                  <div className={"grid grid--2--cols"}>
                    <div>
                      <label htmlFor="material">{t("visa_mobile")!}</label>
                      <input
                        {...register("mobile", {
                          required: true,
                          minLength: 10,
                          maxLength: 10,
                        })}
                        className="textbox"
                        placeholder={t("0599000000")!}
                        type="textbox"
                      />
                    </div>
                    <div>
                      <label htmlFor="email">{t("visa_email")!}</label>
                      <input
                        {...register("email", {
                          required: true,
                          validate: {
                            minLength: (v) => v!.length >= 5,
                            matchPattern: (v) =>
                              /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                                v!
                              ),
                          },
                        })}
                        className="textbox"
                        placeholder={t("ContactInfo_email")!}
                        type="textbox"
                      />
                    </div>
                  </div>
                  <div className={"grid grid--1--col"}>
                    <label htmlFor="applicationType">
                      {t("visa_application_type")!}
                    </label>
                    <select
                      id="certificatetype"
                      defaultValue={-1}
                      {...register("applicationType", {
                        validate: (value) =>
                          value !== -1 || "Please select an application",
                        onChange: (e) => {
                          const selectedId = e.target.value;
                          const selectedApplication = applications.find(
                            (app) => app.esaddedCode === selectedId
                          );
                          setPrice(selectedApplication?.amount);
                          setCurrency(selectedApplication?.currencyName ?? "");
                        },
                      })}
                    >
                      <option key={-1} value={-1} disabled>
                        {t("visa_select_application")}
                      </option>
                      {applications &&
                        applications?.map((application) => (
                          <option
                            key={application.esaddedCode}
                            value={application.esaddedCode}
                          >
                            {i18n.language == "ar"
                              ? application.nameAr
                              : application.name}
                          </option>
                        ))}
                    </select>
                    {price != null && price != 0 ? (
                      <div className={"grid grid--2--cols"}>
                        <div>
                          <label htmlFor="price">{t("visa_price")!}</label>
                          <span id="price" dir="ltr">
                            {price} {currency}
                          </span>
                        </div>
                        <div>
                          <label htmlFor="pricecomm">
                            {t("visa_price_commession")!}
                          </label>

                          <span dir="ltr">
                            {/^\d+$/.test(price.toString())
                              ? `${formatCurrency(
                                  truncateTo2Decimals(
                                    price * COMMISSION_PERCENTAGE
                                  ).toString()
                                )} ${currency} `
                              : "—"}
                          </span>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="grid grid--2--cols formBox">
                  <button
                    className="btn"
                    onClick={handleSubmit((d) => {
                      onSubmit(d);
                    })}
                  >
                    {t("visa_process")}
                  </button>
                  <button
                    className="btn goldbutton"
                    onClick={() => navigate("/")}
                  >
                    {t("visa_back_to_login_page")}
                  </button>
                </div>
              </form>
            ) : (
              <div className="grid grid--1--cols">
                <div>{msg}</div>
                <button
                  className="btn goldbutton"
                  onClick={() => navigate("/")}
                >
                  {t("visa_back_to_login_page")}
                </button>
              </div>
            )}
          </div>
        </section>
      )}

      <Modal
        show={openModal}
        onHide={handleCloseModal}
        className={classes.modal}
      >
        <Modal.Header>{t("visa_popup_title")} </Modal.Header>
        <Modal.Body>
          <iframe
            src={paymentUrl}
            style={{ width: "100%", height: "700px", border: "none" }}
            title="Payment Authorization"
            ref={iframeRef}
          />
        </Modal.Body>
      </Modal>
    </header>
  );
};

export default LahzaHero;
